export const SMALL_WIDTH = 500;
export const SMALL_HEIGHT = 300;
export const SMALL_GRID = 40;
export const MEDIUM_WIDTH = 800;
export const MEDIUM_HEIGHT = 450;
export const MEDIUM_GRID = 64;
export const LARGE_WIDTH = 1140;
export const LARGE_HEIGHT = 600;
export const LARGE_GRID = 92;
export const MARGINS = 30;